import { Box, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import React from 'react';
import Markdown from 'react-markdown';

import { injectTSDI } from '../../core/common/tsdi';
import { I18n } from '../../core/i18n';
import { Title } from './components';

type NotificationType = 'NOT_FOUND' | 'ERROR';

interface NotificationProps {
    link?: string;
    type: NotificationType;
}

export const Notification = observer(
    (props: NotificationProps): React.ReactElement => {
        const { link, type } = props;

        const { translate } = injectTSDI(I18n);

        const isError = type === 'ERROR';

        return (
            <Box
                flexGrow={1}
                display="flex"
                marginTop={18}
                paddingLeft={4}
                paddingRight={4}
                paddingBottom={4}
                alignItems="center"
                flexDirection="column"
            >
                <Box display="flex" flexDirection="column" maxWidth="700px">
                    <Title align="center">
                        {translate(
                            isError
                                ? 'comm.center.marketing.consent.error.title'
                                : 'comm.center.marketing.consent.no.pending.title'
                        )}
                    </Title>
                    <Box marginTop={8}>
                        <Typography>
                            {translate(
                                isError
                                    ? 'comm.center.marketing.consent.error.message'
                                    : 'comm.center.marketing.consent.no.pending.message'
                            )}
                        </Typography>
                    </Box>
                    {!isError && link && (
                        <Typography component="div">
                            <Markdown components={{ p: 'div' }}>
                                {translate(
                                    'comm.center.marketing.consent.no.pending.link.message',
                                    link
                                )}
                            </Markdown>
                        </Typography>
                    )}
                </Box>
            </Box>
        );
    }
);
